import { FantomRunState } from './slice';

export const selectFantomRunData = (state: { fantomRun: FantomRunState }) => state.fantomRun.data;
export const selectFantomRunLoading = (state: { fantomRun: FantomRunState }) =>
  state.fantomRun.loading;
export const selectFantomRunError = (state: { fantomRun: FantomRunState }) => state.fantomRun.error;
